import { AxiosError, HttpStatusCode } from 'axios';

import { useMutation } from '@tanstack/react-query';
import { useLocation } from 'react-router';

import { useAvApi } from '@app-velocity/av-api-v2';

import { UserUpdatePasswordDto } from '../dto/UserUpdatePasswordDto';

export const useUpdatePasswordMutation = () => {
  const { users } = useAvApi();
  const location = useLocation();

  return useMutation<boolean, AxiosError, UserUpdatePasswordDto>({
    mutationKey: ['users', 'update-password'],
    mutationFn: async ({ password }) => {
      const params = new URLSearchParams(location.search);
      const resetPwdToken = params.get('resetPwdToken');

      if (!resetPwdToken) {
        return false;
      }

      const { status } = await users.putV2UsersPasswordReset(
        {
          newPassword: password,
          resetPwdToken,
        }
      );

      return status === HttpStatusCode.Ok || status === HttpStatusCode.Created;
    },
  });
};
